
<template>
  <div class="detail">
    <h3>{{ detail.title }}</h3>
    <h4>
      <span>信息来源：{{ detail.source }}</span>
      <span>信息时间：{{ detail.logintime }}</span>
    </h4>
    <div class="content" v-html="detail.content"></div>
  </div>
</template>

<script>
import request from '@/util/request'
export default {
  data () {
    return {
      detail: {}
    }
  },
  created () {
    request({
      method: 'post',
      data: {
        id: this.$route.query.id
      },
      url: '/api/newsDetail'
    }).then(res => {
      this.detail = res.data.data
      console.log(res)
    })
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {

  },
};
</script>
<style>
.content > p > span {
  font-size: 28px !important;
  font-family: 楷体, 楷体_GB2312 !important;
}
.content > p > a {
  text-decoration: underline !important;
}
</style>
<style scoped>
.detail {
  padding: 41px 260px 60px 260px;
  margin: 0 auto;
  margin-bottom: 30px;
  width: 1300px;
  height: auto;
  min-height: 500px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.detail h3 {
  max-width: 1200px;
  margin: 0 auto;
  height: 52px;
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  line-height: 52px;
  text-align: center;
  color: #333333;
  letter-spacing: 3px;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.detail h4 {
  margin: 0 auto;
  padding: 33px 0;
  width: 750px;
  font-size: 28px;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}

.detail h4 span {
  display: block;
  width: auto;
  height: 16px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #999999;
}

.detail .content {
  text-indent: 2em;
  width: 1300px;
  height: auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #666666;
  overflow: hidden;
}
</style>